import { render, staticRenderFns } from "./saldosActualesPorDelegacion.vue?vue&type=template&id=859601dc&scoped=true"
import script from "./saldosActualesPorDelegacion.vue?vue&type=script&lang=ts"
export * from "./saldosActualesPorDelegacion.vue?vue&type=script&lang=ts"
import style0 from "./saldosActualesPorDelegacion.vue?vue&type=style&index=0&id=859601dc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "859601dc",
  null
  
)

export default component.exports